import type { LucideIcon } from "lucide-react";
import type * as React from "react";
import { Link } from "react-router";
import {
	SidebarGroup,
	SidebarGroupContent,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
} from "@/components/ui/sidebar";

export type SecondaryNavItem = {
	title: string;
	icon: LucideIcon;
	url?: string;
	onClick?: () => void;
};

export function NavSecondary({
	items,
	...props
}: {
	items: SecondaryNavItem[];
} & React.ComponentPropsWithoutRef<typeof SidebarGroup>) {
	return (
		<SidebarGroup {...props}>
			<SidebarGroupContent>
				<SidebarMenu>
					{items.map((item) => (
						<SidebarMenuItem key={item.title}>
							<SidebarMenuButton asChild size="sm">
								{item.url ? (
									<Link to={item.url}>
										<item.icon />
										<span>{item.title}</span>
									</Link>
								) : item.onClick ? (
									<button onClick={item.onClick} type="button">
										<item.icon />
										<span>{item.title}</span>
									</button>
								) : null}
							</SidebarMenuButton>
						</SidebarMenuItem>
					))}
				</SidebarMenu>
			</SidebarGroupContent>
		</SidebarGroup>
	);
}
